module.exports = __webpack_public_path__ + "02a5e00ef9f5e6c25f5a219ec8592ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 17
// module chunks = 0